import React, { Component } from 'react';

import Action from '../Helper/Grid/Action';
import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Tarif from '../Entity/Tarif'

/**
* Class TarifList
* TarifList view component
**/
class TarifList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Tarif;

    // Filter list
    const filters = [{
      title: "Nom du tarif",
      type: "text",
      name: "libelle",
      rowIdx: 1
    },{
      title: "Date de début",
      type: "dateinterval",
      name: "dateValiditeDebut",
      rowIdx: 1
    },{
      title: "Date de fin",
      type: "dateinterval",
      name: "dateValiditeFin",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes tarifs</h2>
        <GridFilter title="Filtrer les tarifs" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Tarifs" ref="gridTarif" path="tarifs" objectPath="tarifs" objectClass={objectClass} height="400px"
          createActionsFunction={this.createActions} trClassNameFunction={this.trClassName} hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs.gridTarif;
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs.gridTarif;
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * applyDateIntervalFilter
  * Filters the grid
  **/
  applyDateIntervalFilter(fieldName, values) {
    const grid = this.refs.gridTarif;
    grid.applyDateIntervalFilter(fieldName, values);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs.gridTarif;
    grid.clearFilters();
  }

  /**
  * createActions
  * Creates row actions buttons
  **/
  createActions(cell, row, opt) {
    let mode = this.props.mode;
    // Check if Tarif is valid comparing start and end dates
    // let today = new Date();
    // today.setHours(0, 0, 0, 0);
    //
    // if(!(row instanceof Object &&
    //   (!(row.dateValiditeDebut instanceof Date) || row.dateValiditeDebut <= today) &&
    //   (!(row.dateValiditeFin instanceof Date) || row.dateValiditeFin >= today))) {
    //   mode = "readonly";
    // }

    const props = {
      object: row,
      objectClass: this.props.objectClass,
      parentGrid: this,
      fields: this.state.fields,
      mode: mode,
      isGeom: this.props.isGeom === true,
      withoutView: this.props.isGeom === true
    };

    const component = <Action {...props}></Action>;
    return component;
  }

  /**
  * trClassName
  * Return a custom tr className for invalid Tarif
  **/
  trClassName(row, rowIndex) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (!(row instanceof Object &&
           (!(row.dateValiditeDebut instanceof Date) || row.dateValiditeDebut <= today) &&
           (!(row.dateValiditeFin instanceof Date) || row.dateValiditeFin >= today))) ?
              "invalid" : null;
  }

}
export default TarifList;



// WEBPACK FOOTER //
// ./src/views/Search/TarifList.js